export const getDaysToFinish = (finishDate: Date) => {

    const currentDate = new Date();
    const result = Math.ceil((finishDate.getTime() - currentDate.getTime()) / (1000 * 60 * 60 * 24));

    return result
}export const getDaysToFinish = (finishDate: Date) => {

    const currentDate = new Date();
    const result = Math.ceil((finishDate.getTime() - currentDate.getTime()) / (1000 * 60 * 60 * 24));

    return result
}